// The gutter was 680 of 1650 — two fifths of the chart spent on names, which
// squeezed nine centuries of plot into the remainder. It is 330 now, and a name
// too long for it is cut to width with an ellipsis (see measureText.js); the
// full name stays on the row's accessible name and in its tooltip.
export const CHART = Object.freeze({
  width: 1290,
  labelGutter: 330,
  nameX: 20,
  // Dates are right-anchored here, at the gutter's inside edge.
  dateX: 322,
  // Clear water between a name and the dates it must not run into.
  nameGap: 10,
  nameSize: 15,
  dateSize: 12,
  plotWidth: 940,
  rowHeight: 36,
  top: 66,
  minimumHeight: 138,
  bottomPadding: 18,
  rightPadding: 20,
  // Below this the chart SCROLLS rather than shrinking. Squeezing 1290 units
  // into a 375px phone renders the names at 4px, which is not a chart of
  // anything. Drawn 1:1, so at the design width nothing is scaled at all.
  minimumPixelWidth: 1290,
  // The band the year labels occupy, and how close to the foot of the chart it
  // is allowed to float before it stops. Past that the axis would be labelling
  // nothing.
  axisHeight: 32,
  axisFloor: 44
});

export const ZOOM = Object.freeze({
  minimum: 0.75,
  fit: 1,
  maximum: 2.5,
  step: 0.25
});

export const DEFAULT_TIMELINE_STATE = Object.freeze({
  mainstreamFigures: true,
  allFigures: false,
  events: false,
  periods: false,
  biblical: false,
  islamic: false,
  egyptian: false
});

export const TRADITION_LAYERS = Object.freeze([
  {
    slug: "biblical",
    label: "Include biblical",
    legend: "Biblical / Jewish mystical layer",
    summary: "biblical, Merkavah and Kabbalistic entries"
  },
  {
    slug: "islamic",
    label: "Include Muslim / Islamicate history",
    legend: "Muslim / Islamicate layer",
    summary: "Muslim and Islamicate entries"
  },
  {
    slug: "egyptian",
    label: "Include Egyptian",
    legend: "Egyptian human figures",
    summary: "Egyptian historical figures"
  }
]);

export const PERIOD_COLORS = Object.freeze([
  "#8bb8c9", "#9ca9d1", "#b29bc8", "#c493b7", "#ca9298", "#c49a82",
  "#aaad78", "#87b28a", "#75b2a5", "#71a9c1", "#809dcc", "#998fc8",
  "#b685bc", "#c184a8", "#c28c8c", "#b99b78", "#9ca778", "#7fac95"
]);

export function chartHeight(rowCount) {
  return Math.max(
    CHART.top + (rowCount * CHART.rowHeight) + CHART.bottomPadding,
    CHART.minimumHeight
  );
}

export function projectYear(year, axis) {
  const clamped = Math.max(axis.start, Math.min(axis.end, year));
  return CHART.labelGutter + ((clamped - axis.start) / (axis.end - axis.start)) * CHART.plotWidth;
}

export function diamondPoints(x, y, radius = 5) {
  return `${x},${y - radius} ${x + radius},${y} ${x},${y + radius} ${x - radius},${y}`;
}

export function trianglePoints(x, y, radius = 5) {
  return `${x},${y - radius} ${x + radius},${y + radius} ${x - radius},${y + radius}`;
}

export function itemKey(item) {
  return `${item.kind}-${item.slug}`;
}
